import module from "./index";
import SidebarLayout from "../../components/SidebarLayout";

const AdminLayout = (props) => {
  return <SidebarLayout module={module} submodules={module.submodules} />;
};

export default AdminLayout;
